// Camera framing shared by rendering (main.ts) and picking (render/picking.ts).
//
// The design FOV applies to the *shorter* screen axis: in landscape it is the
// vertical FOV as-is; in portrait the vertical FOV widens so the horizontal
// FOV stays at the design value and the cube never overflows the narrow side.
// The camera itself never moves, so the cube's on-screen size relative to the
// shorter axis is identical in both orientations.

export interface Camera {
  fovY: number; // effective vertical FOV for this aspect
  aspect: number;
  dist: number; // camera offset along +z (view = translation(0, 0, -dist))
}

const FOV = Math.PI / 4; // design FOV along the shorter screen axis
const DIST = 2.2; // chosen so the cube nearly fills the shorter screen axis

export function frameCube(aspect: number): Camera {
  const fovY = aspect >= 1 ? FOV : 2 * Math.atan(Math.tan(FOV / 2) / aspect);
  return { fovY, aspect, dist: DIST };
}
